import React from 'react';

function ConfirmDialogModal({ dialog, onClose, onConfirm }) {
  if (!dialog) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{dialog.title || 'Confirm action'}</h3>
        <p className="modal-text">{dialog.message || 'Are you sure you want to proceed?'}</p>
        <div className="modal-actions">
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn-delete modal-delete" onClick={onConfirm}>
            {dialog.actionLabel
              ? dialog.actionLabel
              : dialog.type === 'unlock'
                    ? 'Unlock'
                    : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialogModal;
